import React, { useEffect, useMemo, useState } from 'react';
import {
    Table,
    Row,
    Col,
    Card,
    CardBody,
    Form,
    Input, Label, Modal
} from "reactstrap";
import { useTable, useGlobalFilter, usePagination } from 'react-table';
import { Link, useNavigate } from 'react-router-dom';
import Swal from "sweetalert2"
import swal from "sweetalert"
import Select from "react-select"
import AddHoliday from "../../../assets/images/Holiday/AddHoliday.jpg"
import EditHoliday from "../../../assets/images/Holiday/EditHoliday.jpg"

// css
// import '../../../assets/css/Settings/Setting.css';
// import "../../../assets/css/Finance/Style/PayrollManagement/payroll_management.css"
import "../../../assets/css/Finance/Style/Festival/festival.css"


// commom 
import Pagination from 'components/Common/Pagination';

import { CSVLink } from "react-csv";
import configure from 'configure';
// import { Modal } from 'bootstrap/dist/js/bootstrap.bundle.min';

function TableContainer({ columns, data, setAddFestival }) {

    const [fixedContent, setFixedContent] = useState(false);
    const [formPopup, setFormPopup] = useState(false);


    // const [salaryCalculation, setSalaryCalculation] = useState(false);

    const navigate = useNavigate()

    document.addEventListener('scroll', () => {
        if (window.scrollY > 256) {
            setFixedContent(true);
        }
        else {
            setFixedContent(false);
        }
    })

    // Use the state and functions returned from useTable to build your UI
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        state,
        previousPage,
        nextPage,
        canPreviousPage,
        canNextPage,
        gotoPage,
        setPageSize,
        pageOptions,
        setGlobalFilter,
        prepareRow
    } = useTable({
        columns,
        data
    },
        useGlobalFilter,
        usePagination
    );

    const { pageIndex, pageSize, globalFilter } = state;


    // Functionality to export table data to CSV //
    const excelColumns = []
    columns.forEach(column => {
        excelColumns.push(column.Header)
    });

    const csvData = [
        excelColumns,
        ...data.map(({ id, date, title, invoiceNo, customer, category, debit, credit }) => [
            id, date, title, invoiceNo, customer, category, debit, credit
        ]),
    ];
    // ======================================================= //


    const Year = [
        { label: "2020", value: "1" },
        { label: "2021", value: "2" },
        { label: "2022", value: "3" },
        { label: "2023", value: "4" },
        { label: "2024", value: "5" },
        { label: "2025", value: "6" },
      ]
    // Render the UI for your table
    return (
        <div >
            {/* fixed buttons */}
            <div className={`flex-column fixed-buttons ${fixedContent ? 'd-flex' : 'd-none'}`}>
                {/* <CSVLink
                    className='btn btn-success border-radius fix-btn'
                    filename="gst_ztpl.csv"
                    data={csvData}>
                    <i className='fas fa-download me-2 icon-center'></i>
                    <span>Export</span>
                </CSVLink> */}

                <button className=" btn btn-save btn-label"
                    onClick={()=> setAddFestival(true)}
                >
                    <i className="fas fa-plus me-2 label-icon"></i>
                    Festival
                </button>
                <button onClick={() => navigate(-1)} className='btn btn-red border-radius fix-btn' >
                    <i className='dripicons-cross me-2 icon-center'></i>
                    <span>Cancel</span>
                </button>
            </div>
            <Row className='mb-2'>
               
                <Col md={12} className='mb-4'>
                        <div className='d-flex '>
                            <div className='col-md-8'>
                                <h5 className='text-dark'>India</h5>
                                <div className=" d-flex justify-content-start align-items-center">
                                        <div className="col-md-4 mb-3">
                                            <label htmlFor="">Year</label>
                                            <Select            
                                            placeholder="Select Year"
                                            className="basic-multi-select rounded-0"
                                            // classNamePrefix=" select"
                                            options={Year}
                                            />
                                        </div>
                                        <div className="col-md-4 d-flex justify-content-start align-items-center gap-2 ms-4 mt-2">
                                            <button className="btn  btn-purple">
                                                <i className="fas fa-filter search-icon me-1 icon-center"></i>{" "}
                                                Filter
                                            </button>
                                            <a
                                                className="btn  btn-red"
                                                
                                            >
                                                <i className="dripicons-cross me-1 icon-center"></i>{" "}
                                                Clear
                                            </a>
                                        </div>
                                </div>
                            </div>
                            <div className="col-md-4 d-flex justify-content-end align-items-center mt-4">
                                <div className=" d-flex justify-content-end align-items-center mt-2">
                                    <button className=" btn btn-save btn-label"
                                    onClick={()=> setAddFestival(true)}
                                    >
                                    <i className="fas fa-plus me-2 label-icon"></i>
                                        Festival
                                    </button>
                                </div>
                            </div>           
                        </div>
                              
                </Col>
                <Col>
                    <select
                        className="border-radius form-select"
                        style={{ width: '100px' }}
                        value={pageSize}
                        onChange={(e) => setPageSize(e.target.value)}
                    >
                        {[10, 20, 30, 40, 50].map(pageSize => (
                            <option key={pageSize} value={pageSize}>
                                Show {pageSize}
                            </option>
                        ))}
                    </select>
                </Col>
                <Col md={8} className='d-flex justify-content-end'>
                    <div className=''>
                        <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
                            <div className="position-relative">
                                <label htmlFor="search-bar-0" className="search-label">
                                    <span id="search-bar-0-label" className="sr-only">
                                        Search this table
                                    </span>
                                    <input
                                        onChange={(e) => setGlobalFilter(e.target.value)}
                                        id="search-bar-0"
                                        type="text"
                                        className="border-radius form-control rounded h-100"
                                        placeholder={` Search...`}
                                        value={globalFilter || ''}
                                    />
                                </label>
                                <i className="bx bx-search-alt search-icon"></i>
                            </div>
                        </div>

                    </div>
                    <div >
                        {/* <button onClick={() => setFormPopup(!formPopup)} className='btn btn-outline-secondary border-radius me-2'><i className='fas fa-filter'></i></button> */}
                        {/* CSV download btn */}
                        {/* <CSVLink
                            className='border-radius btn text-white me-2 btn-success'
                            filename="gst_ztpl.csv"
                            data={csvData}>
                            <i className="fas fa-download me-2 icon-size"></i> Export CSV
                        </CSVLink> */}

                        {/* <button className='border-radius btn text-white me-2 btn-success'>
                            <i className="fas fa-download me-2 icon-size"></i> Export CSV    
                        </button> */}

                        {/* <button onClick={() => navigate(-1)} className="border-radius btn btn-red"><i className='dripicons-cross me-2 icon-center'></i>CANCEL</button> */}
                    </div>
                </Col>
            </Row>

            <div className='position-relative'>
                <Table className='table table-bordered mt-3' {...getTableProps()}>
                    <thead className={`${fixedContent ? 'fixed-setting-header' : ''} fix-gst-header`}>
                        {
                            headerGroups.map((headerGroup, i) => (
                                <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                                    {
                                        headerGroup.headers.map((column, index) => (
                                            <th key={index} className={`t-col-${index + 1} ${column.className}`} {...column.getHeaderProps()}>{column.render("Header")}
                                                {/* {
                                                    column.isInfoIcon ?
                                                        <i title='info' className='bx bx-info-circle ms-1 info-icon'></i> : null} */}
                                            </th>
                                        ))
                                    }
                                </tr>
                            ))
                        }
                    </thead>

                    <tbody className="fix-gst-header" {...getTableBodyProps()}>
                        {
                            page.map((row, i) => {
                                prepareRow(row);
                                return (
                                    <tr className='row-hover' {...row.getRowProps()} key={i}>
                                        {
                                            row.cells.map((cell, index) => {
                                                return <td key={index} className={`t-col-${index + 1} ${cell.column.className}`} {...cell.getCellProps()}>{cell.render("Cell")}</td>;
                                            })
                                        }
                                    </tr>
                                );
                            })
                        }
                    </tbody>
                </Table>

            </div>

            {/* Pagination */}
            <Row className="justify-content-md-end justify-content-center align-items-center">
                <Pagination
                    gotoPage={gotoPage}
                    previousPage={previousPage}
                    canPreviousPage={canPreviousPage}
                    nextPage={nextPage}
                    canNextPage={canNextPage}
                    pageIndex={pageIndex}
                    pageOptions={pageOptions}
                />
            </Row>
        

                    
        </div>
    );
}

const IndianFestival = () => {

    const [addFestival, setAddFestival] = useState(false);
    const [editFestival, setEditFestival] = useState(false);

    document.addEventListener("keydown", e => {
        if (e.key === "Escape") setAddFestival(false), setEditFestival(false)
      })

    const columns = useMemo(
        () => [
          {
            Header: "ID",
            accessor: "id",
            isInfoIcon: false,
            className: "text-center id_box",
          
          },
          {
            Header: ()=>{
              return <div>Festival Name</div>
            },
            accessor: "festival_name",
            grow: false,
            className : "festival_name_box",
            // Cell: cellProps => {
    
            //   return (
            //     <div className="text-center d-flex justify-content-center align-items-center"
            //     >
            //       {cellProps.row.original.location == "1" ? (
            //         <img
            //           src={India}
            //           className=" mx-1 location-img text-center"
            //           alt="flag"
            //           height="20"
            //           width="30"
            //         />
            //       ) : (
            //         <img
            //           src={Uk}
            //           className=" mx-1 location-img"
            //           alt="flag"
            //           height="20"
            //           width="30"
            //         />
            //       )}
            //     </div>
            //   )
            // },
            // isInfoIcon: true,
          },
    
          {
            Header: ()=>{
              return <div style={{textAlign :"center"}}>Date</div>
            },
            accessor: "date",
            isInfoIcon: true,
            className: "date_box",
            Cell : row => <div style={{textAlign : "center"}}>{row.value}</div>
          },
          {
            Header: ()=>{
              return <div style={{textAlign :"center"}}>Day</div>
            },
            accessor: "day",
            isInfoIcon: true,
            className: "day_box",
            Cell : row => <div style={{textAlign : "center"}}>{row.value}</div>
          },
        
          {
            Header: "Comment",
            accessor: "comment",
            isInfoIcon: true,
            className: "comment_box",
    
          },
      
        {
            Header: ()=> {
              return <div style={{textAlign : "center"}}>Action</div>
            },
            accessor: "action",
            className: "text-center festival_action_box",
            Cell: cellProps => {
              const isDelete = async () => {
                swal({
                  title: "Are you sure?",
                  text: "You want to Delete this Festival !",
                  icon: "warning",
                  buttons: true,
                  dangerMode: true,
                }).then (async willDelete => {
                    if(willDelete){
                      setLoading(true)
                      const formData = new FormData()
                      // formData.append("user_id", localStorage.getItem("auth_id"))
                      // formData.append("expense_id", cellProps.row.original.id)
                      try{
                         const response = await axios({
                            method : "get",
                            url : `${configure.nodeApi}/deleteBudgetExpense/${cellProps.row.original.id}`,
                            data : formData,
                            headers: {
                              Accept: "application/json",
                              "Content-Type": "application/json",
                            },
                         }).then(response => {
                          swal({
                            icon: "success",
                            text: "Festival Deleted Successfully",
                          }).then(data => {
                            setDatas(response.data.data?.expense)
                          })
                          setLoading(false)
                        }) 
                      }catch (err) {
                        swal({
                          icon: "error",
                          text: "Something went wrong",
                        })
                        setLoading(false)
                      }
                    }
                })
              }
       
    
              return (
                <div className="d-flex justify-content-center">
                  
                  <button
                    onClick={() => setEditFestival(true)}
                    className="btn btn-sm me-1 btn-outline-secondary"
                    title="Edit Festival"
                  >
                    <i className="fa fa-pencil-alt"></i>
                  </button>
                  <button
                     onClick={() => isDelete()}
                    className="btn btn-sm me-1 btn-outline-secondary"
                    title="Delete Festival"
                  >
                    <i className="fa fa-trash-alt text-danger"></i>
                  </button>
                  {/* <a
                        onClick={() => isDelete()}
                        className="dropdown-item"
                        title="delete"
                      >
                        <i className="fas fa-trash-alt pr-10 text-danger"></i>{" "}
                  
                  </a> */}
             
                </div>
              )
            },
          },
        ],
        []
      )

      const data = [
        {
          id: 1,
          festival_name: "Dhuleti",
          date : "08-03-2023",
          day : "Wednesday",
          comment : "day of colours",
         
        },
        {
          id: 2,
          festival_name: "Diwali 2nd day",
          date : "08-03-2023",
          day : "Wednesday",
          comment : "day of colours",
        },
        {
          id: 3,
          festival_name: "Diwali 3rd day",
          date : "08-03-2023",
          day : "Wednesday",
          comment : "day of colours",
        },
        {
          id: 4,
          festival_name: "Diwali First Day",
          date : "08-03-2023",
          day : "Wednesday",
          comment : "day of colours",
        },
        {
          id: 5,
          festival_name: "First Saturday",
          date : "08-03-2023",
          day : "Wednesday",
          comment : "day of colours",
        },
        {
          id: 6,
          festival_name: "Second Saturday",
          date : "08-03-2023",
          day : "Wednesday",
          comment : "day of colours",
        },
     
      ]

    return (
        <>
            <div>
                <Row className='ms-0 pe-0'>
                    <Col lg={12} className='p-0'>
                        <Card>
                            <CardBody>   
                                <TableContainer 
                                columns={columns} 
                                data={data} 
                                setAddFestival = {setAddFestival}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                {/* Add Festival Popup */}
                <Modal isOpen={addFestival} size="xl" className="" centered>
                    <div className="modal-header pe-4" >
                        <h5 className="modal-title mt-0">Add Festival</h5>
                        <button
                        type="button"
                        onClick={() => {
                            setAddFestival(false)
                        }}
                        className="btn-modal-close"
                        >
                        <span aria-hidden="true" className="btn-modal-span">
                            &times;
                        </span>
                        </button>
                    </div>

                    <div className="modal-body pe-4" >
                        <Form className="row d-flex justify-content-center align-items-center">
                            <div className="col-md-5 d-flex justify-content-end align-items-center ps-3">
                            <div className="text-center">
                                <img src={AddHoliday} alt="Addepe" style={{width : "90%"}} />
                            </div>
                            </div>

                            <div className="col-md-6 d-flex flex-column ">
                            <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
                                <div className="col-md-8  ps-2">
                                    <Label htmlFor="formrow-firstname-Input">Festival Name <span className="text-danger">*</span></Label>                 
                                    <div className="d-flex justify-content-start align-items-center gap-2">
                                    <Input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Festival Name"
                                    />  
                                    </div>
                                </div>
                                <div className="col-md-4 ps-2">

                                    <Label htmlFor="formrow-firstname-Input">
                                    Date <span className="text-danger">*</span>
                                    </Label>
                                    <Input
                                        type="date"
                                        className="form-control"
                                    /> 
                                </div>
                                
                            
                            </div>
                            <div className="col-md-12">
                                
                                <div className="col-md-12 ps-2">
                                    <Label htmlFor="formrow-firstname-Input">
                                    Comment  <span className="text-danger">*</span>
                                    </Label>
                                    <textarea
                                    type="text"
                                    // value={lead_belong}
                                    placeholder="Add Comment Here.."
                                    className="form-control" 
                                    style={{height:"150px"}}                  
                                    />
                                </div>
                                
                            </div>
                            
                            <div className="my-4 text-center">
                                <button className=" btn btn-save btn-label">
                                    <i className="fas fa-save me-2 label-icon"></i>
                                    Save
                                </button>
                                <a
                                    
                                    className=" btn ms-md-2 btn-red btn-label"
                                    >
                                    <i className="dripicons-cross me-2 icon-center label-icon"></i>
                                    CANCEL
                                    </a>  
                                </div>
                        </div>
                        
                        
                        {/* </div> */}
                        </Form>
                    </div>
                </Modal>

                  {/* Edit Festival Popup */}
                    <Modal isOpen={editFestival} size="xl" className="" centered>
                                <div className="modal-header pe-4" >
                            <h5 className="modal-title mt-0">Edit Festival</h5>
                            <button
                            type="button"
                            onClick={() => {
                                setEditFestival(false)
                            }}
                            className="btn-modal-close"
                            >
                            <span aria-hidden="true" className="btn-modal-span">
                                &times;
                            </span>
                            </button>
                        </div>

                        <div className="modal-body pe-4" >
                            <Form className="row d-flex justify-content-center align-items-center">
                                <div className="col-md-5 d-flex justify-content-end align-items-center ps-3">
                                <div className="text-center">
                                    <img src={EditHoliday} alt="Addepe" style={{width : "90%"}} />
                                </div>
                                </div>

                                <div className="col-md-6 d-flex flex-column ">
                                <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
                                    <div className="col-md-8  ps-2">
                                        <Label htmlFor="formrow-firstname-Input">Festival Name <span className="text-danger">*</span></Label>                 
                                        <div className="d-flex justify-content-start align-items-center gap-2">
                                        <Input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Festival Name"
                                        />  
                                        </div>
                                    </div>
                                    <div className="col-md-4 ps-2">

                                        <Label htmlFor="formrow-firstname-Input">
                                        Date <span className="text-danger">*</span>
                                        </Label>
                                        <Input
                                            type="date"
                                            className="form-control"
                                        /> 
                                    </div>
                                    
                                
                                </div>
                                <div className="col-md-12">
                                    
                                    <div className="col-md-12 ps-2">
                                        <Label htmlFor="formrow-firstname-Input">
                                        Comment  <span className="text-danger">*</span>
                                        </Label>
                                        <textarea
                                        type="text"
                                        // value={lead_belong}
                                        placeholder="Add Comment Here.."
                                        className="form-control" 
                                        style={{height:"150px"}}                  
                                        />
                                    </div>
                                    
                                </div>
                                
                                <div className="my-4 text-center">
                                    <button className=" btn btn-save btn-label">
                                        <i className="fas fa-save me-2 label-icon"></i>
                                        Save
                                    </button>
                                    <a
                                        
                                        className=" btn ms-md-2 btn-red btn-label"
                                        >
                                        <i className="dripicons-cross me-2 icon-center label-icon"></i>
                                        CANCEL
                                        </a>  
                                    </div>
                            </div>
                            
                            
                            {/* </div> */}
                            </Form>
                        </div>
                    </Modal>
            </div>
        </>
    )
}

export default IndianFestival